export const PAGAMENTO_ESTORNO = "PAGAMENTO_ESTORNO";
export const PAGAMENTO_DETALHE = "PAGAMENTO_DETALHE";
export const PAGAMENTO_ESTORNO_FEITOS = "PAGAMENTO_ESTORNO_FEITOS";
